import { render } from "./FavoritesIcon.vue?vue&type=template&id=a3e0aaec"
import script from "./FavoritesIcon.vue?vue&type=script&lang=js"
export * from "./FavoritesIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__